import Collapse from "components/Collapse";
import Toggle from "components/Toggle";
import React from "react";
import { CertificationProps } from "../useCertificationsList";

function CertificationRow({
  item,
  ...props
}: {
  item: CertificationProps;
  onClickToggle: (state: boolean | undefined, id: string) => void;
}) {
  const [isOpened, setIsOpened] = React.useState(false);
  const collapseRef = React.useRef<HTMLButtonElement>(null);

  const handleToggleClicked = (state: boolean | undefined) => {
    if ((!isOpened && state) || (isOpened && !state)) {
      collapseRef?.current?.click();
    }
    props.onClickToggle(state, item.id);
  };

  return (
    <Collapse
      containerClassName="mb-4 border border-gray-300 rounded-md overflow-hidden"
      headerClassName="flex bg-white border-b-gray-300"
      key={item.id}
      defaultClose
      onOpen={(state) => setIsOpened(state)}
      headerTitle={
        <div className="flex items-center w-full">
          <Toggle
            current={Boolean(item.checked)}
            onChange={handleToggleClicked}
            label=""
          />
          <div className="flex items-center">
            {item?.logo && <img src={item.logo} className="h-[24px] ml-4" />}
            <div className="text-base font-semibold text-gray-700 ml-2">
              {item.name}
            </div>
          </div>
        </div>
      }
      ref={collapseRef}
    >
      <div className="bg-white">{item.content}</div>
    </Collapse>
  );
}

export default CertificationRow;
